import React from "react";
import { shadeColor } from "../../../../../helpers/shade-color";
import { useTheme } from "styled-components";
import { Container, DotElement, Title } from "../styled";
import EditableText from "../inline-edit/EditableText";
import TextEdit from "../TextEdit";

function Dot({ data, isEditable, isTemplate, viewMode }) {
  const theme = useTheme();

  const { borderRadius, accentColor, textColor, displayElements, colorMute } =
    data;

  const accent = accentColor[theme.name];
  const text = textColor[theme.name];
  const bgMuted = `${accent.slice(0, 7)}4d`;
  const textMuted = shadeColor(accent, theme.name === "dark" ? 40 : -40);

  return (
    <Container
      bgClr={colorMute ? bgMuted : accent}
      radius={borderRadius}
      addMarginLeft={viewMode === "view"}
    >
      <DotElement
        bgClr={colorMute ? accentColor[theme.name] : textColor[theme.name]}
        borderColor={accentColor[theme.name]}
      />
      {displayElements.includes("title") && (
        <Title clr={colorMute ? textMuted : text}>
          <EditableText data={data} isEditable={isEditable} field="title" />
        </Title>
      )}
      {displayElements.includes("text") && (
        <TextEdit
          data={data}
          textColor={colorMute ? textMuted : text}
          isEditable={isEditable}
          isTemplate={isTemplate}
        />
      )}
    </Container>
  );
}

export default Dot;
